import React from "react";
import Hammer from "react-hammerjs";
import classnames from "classnames";
import alertify from "alertifyjs";

import genericdfs from "../helpers/genericdfs";

import Color from "../Color";

import Defs from "./Defs";
import Card from "./Card";
import Connection, { ConnectionRoot } from "./Connection";
import EmployeeCard from "./EmployeeCard";
import ContextMenu from "./ContextMenu";
import ZoomControls from "./ZoomControls";
import LevelControl from "./LevelControl";

let WIDTH;
let HEIGHT;

class Chart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: {},
      contextMenu: false,
      offset: { top: 50, left: 0 },
      scale: 1,
      isOrgView: true,
      isEntityDragging: false,
      isZoomAll: false
    };
    this.zooming = false;
    this.panning = false;
    this.oldDeltaX = 0;
    this.oldDeltaY = 0;
  }

  startEntityDragging = () => this.setState({ isEntityDragging: true });
  stopEntityDragging = () => this.setState({ isEntityDragging: false });

  collapse = id => {
    const { collapsed } = this.state;
    const s = collapsed[id];
    this.setState({ collapsed: { ...collapsed, [id]: !s } });
    this.closeContextMenuIfOpen(true);
  };

  add = id => {
    this.props.openModal("add", { parentId: id }, (entityName, parentId) => {
      this.props.Graph.add(entityName, parentId);
      if (this.state.collapsed[parentId]) this.collapse(parentId);
      this.closeContextMenuIfOpen(true);
    });
  };

  edit = id => {
    const { Graph } = this.props;
    const node = Graph.graphIdMapping[id];
    this.props.openModal("edit", node, (entityName, parentId) => {
      Graph.edit(id, entityName, parentId);
      this.closeContextMenuIfOpen(true);
    });
  };

  delete = id => {
    alertify.confirm(
      "This entity and it's children will be removed, are you sure you want to delete them?",
      () => this.props.Graph.delete(id)
    );
  };

  addEmployees = (id, employees) => {
    this.props.Graph.addEmployees(id, employees);
    // do something else
  };

  entityDrop = (id, droppedId) => {
    const { Graph } = this.props;
    const node = Graph.graphIdMapping[droppedId];
    Graph.edit(droppedId, node.entityName, id);
  };

  onContextMenu = (x, y, id) => {
    this.setState({ contextMenu: { x, y, id } });
  };

  closeContextMenuIfOpen = (force = false) => {
    const { contextMenu } = this.state;
    if (contextMenu || force) this.setState({ contextMenu: false });
  };

  expandOrCollapseLevel = (level, collapse = false) => {
    let idstoeorc = [];
      genericdfs(
        this.state.isOrgView ?
        this.props.Graph.graph : this.props.Graph.employeesHierarchy,
        (node, l) => {
          if (l === level) idstoeorc.push(node.id);
        },
        () => {
          const { collapsed } = this.state;
          for (let id of idstoeorc) collapsed[id] = collapse;
          this.setState({ collapsed });
        }
      );
  };

  dfs(g, x, y, level = 0) {
    const { collapsed, isOrgView } = this.state;
    WIDTH = isOrgView ? 400 : 250;
    HEIGHT = isOrgView ? 200 : 100;
    const CardComponent = isOrgView ? Card : EmployeeCard;
    if (level > this.maxlevel) this.maxlevel = level;
    if (x > this.maxX) this.maxX = x;
    if (y > this.maxY) this.maxY = y;
    this.levelCollapsedStatus[level - 1] = false;
    if (this.levelCollapsedStatus[level] === undefined)
      this.levelCollapsedStatus[level] = true;
    var xused = 0;
    let cardCoords = [];
    var node = (
      <g>
        <g>
          {g &&
            !collapsed[g.id] &&
            g.children &&
            g.children.length &&
            g.children.map(gt => {
              const cx = x + xused;
              const [_node, _x] = this.dfs(gt, cx, y + HEIGHT + 100, level + 1);
              xused += _x;
              cardCoords.push(cx + (_x - 100) / 2);
              return _node;
            })}
        </g>
        {/* <g>
          {!collapsed[g.id] &&
            !isOrgView &&
            g.employees &&
            g.employees.length &&
            g.employees.map(e => {
              if (g.lineManager && e.id === g.lineManager) return null;
              const cx = x + xused;
              const [_node, _x] = this.dfs(
                { lineManager: e.id },
                cx,
                y + HEIGHT + 100,
                level + 1
              );
              xused += _x;
              cardCoords.push(cx + (_x - 100) / 2);
              return _node;
            })}
        </g> */}
        {g &&
        <CardComponent
          id={g.id}
          x={x + (xused ? xused - WIDTH - 100 : 0) / 2}
          y={y}
          entityName={isOrgView ? g.entityName : g.name}
          parentId={g.parentId}
          employees={g.employees}
          employeeDetails={this.props.employees}
          lineManager={isOrgView ? g.lineManager : g.position}
          onContextMenu={this.onContextMenu}
          toggleCollapse={() => this.collapse(g.id)}
          isCollapsed={collapsed[g.id]}
          addEmployees={this.addEmployees}
          isRoot={g.parentId === null}
          openLineManager={this.props.openLineManager}
          onAdd={this.add}
          onEdit={this.edit}
          onDelete={this.delete}
          startEntityDragging={this.startEntityDragging}
          stopEntityDragging={this.stopEntityDragging}
          onEntityDrop={this.entityDrop}
          isAncestor={this.props.Graph.isAncestor}
        />}
        {cardCoords.length && (
          <ConnectionRoot
            x={x + WIDTH * 0.5 + (xused ? xused - WIDTH - 100 : 0) / 2}
            y1={y + HEIGHT}
            y2={y + HEIGHT + 100}
          />
        )}
        {cardCoords.map((cx, _i) => (
          <Connection
            x1={x + WIDTH * 0.5 + (xused ? xused - WIDTH - 100 : 0) / 2}
            y1={y + HEIGHT}
            x2={cx}
            y2={y + HEIGHT + 100}
            key={_i}
          />
        ))}
      </g>
    );
    if (level === 0) {
      this.internaltranslate =
        this.props.width / 2 -
        (x + WIDTH * 0.5 + (xused ? xused - WIDTH - 100 : 0) / 2);
      node = <g transform={`translate(${this.internaltranslate},0)`}>{node}</g>;
    }
    return [
      node,
      g && !collapsed[g.id] && g.children && g.children.length ? xused : WIDTH + 100
    ];
  }

  zoomAll = () => {
    if (!this.state.isZoomAll) this.getZoomAllCamera();
    if (this.state.isZoomAll)
      this.setState({
        offset: this.state.oldOffset,
        scale: this.state.oldScale
      });
    this.setState({ isZoomAll: !this.state.isZoomAll });
  };
  zoomIn = () => this.zoom(6 / 5, 0, 0, true);
  zoomOut = () => this.zoom(5 / 6, 0, 0, true);

  zoom = (scale_factor, clientX, clientY, center_zoom = false) => {
    if (this.zooming) return;
    var { scale, offset } = this.state;
    const { Sizes } = this.props;
    if ((scale < 0.25 && scale_factor < 1) || (scale > 2 && scale_factor > 1))
      return;
    this.zooming = true;
    clientX -= Sizes.sidebarWidth;
    clientY -= Sizes.height - Sizes.chartHeight;
    if (center_zoom) {
      clientX = Sizes.mainWidth / 2;
      clientY = Sizes.chartHeight / 2;
    }
    // client = (offset + x/y) * scale
    // client of oldx/y = client of newx/y (current mouse position)
    // oldx/y = client / scale - offset
    // (newoffset + oldx/y) * newscale = (oldOffset + oldx/y) * oldscale
    const oldX = clientX / scale - offset.left;
    const oldY = clientY / scale - offset.top;
    offset.left = (offset.left + oldX) / scale_factor - oldX;
    offset.top = (offset.top + oldY) / scale_factor - oldY;
    scale *= scale_factor;
    this.setState({ offset, scale, isZoomAll: false }, () => {
      this.zooming = false;
    });
  };

  wheel = e => {
    const { clientX, clientY, deltaY } = e;
    if (deltaY > 0) this.zoom(5 / 6, clientX, clientY);
    else this.zoom(6 / 5, clientX, clientY);
    e.preventDefault();
    return false;
  };

  pan = e => {
    if (this.panning || this.state.isEntityDragging) return;
    this.panning = true;
    var { offset, scale } = this.state;
    offset.left += (e.deltaX - this.oldDeltaX) / scale;
    offset.top += (e.deltaY - this.oldDeltaY) / scale;
    this.oldDeltaX = e.deltaX;
    this.oldDeltaY = e.deltaY;
    this.setState({ offset, scale, isZoomAll: false }, () => {
      this.panning = false;
    });
  };

  panEnd = () => {
    this.panning = false;
    this.oldDeltaX = 0;
    this.oldDeltaY = 0;
  };

  getZoomAllCamera = () => {
    const { width, height } = this.props;
    let scale = width / (this.maxX + 300);
    if (height / (this.maxY + 100) < scale) scale = height / (this.maxY + 100);
    const leftOffset = width / (2 * scale) - this.maxX / 2 + 100;
    this.setState({
      offset: { top: 50, left: leftOffset - this.internaltranslate },
      scale,
      oldOffset: this.state.offset,
      oldScale: this.state.scale
    });
  };

  render() {
    const { height, width, Graph } = this.props;
    const { scale, offset, contextMenu, isOrgView, isZoomAll } = this.state;
    this.maxlevel = 0;
    this.maxX = 0;
    this.maxY = 0;
    this.levelCollapsedStatus = {};
    const dfsrootnode = isOrgView ? this.dfs(Graph.graph, 0, 0)[0] : this.dfs(Graph.employeesHierarchy, 0, 0)[0];
    this.maxX += WIDTH;
    this.maxY += HEIGHT;

    const mainChart = (
      <div
        id="chartContainer"
        style={{ height, width, position: "relative" }}
        onWheel={this.wheel}
      >
        <div style={{ position: "absolute", right: 50, top: -50, zIndex: 2 }}>
          <ZoomControls
            zoomAll={this.zoomAll}
            isZoomAll={isZoomAll}
            zoomIn={this.zoomIn}
            zoomOut={this.zoomOut}
          />
        </div>
        <Hammer onPan={this.pan} onPanEnd={this.panEnd}>
          <svg
            height={height}
            width={width}
            onClick={e => this.closeContextMenuIfOpen()}
          >
            <Defs />
            <g
              transform={
                "matrix(" +
                scale +
                " " +
                "0 0 " +
                scale +
                " " +
                offset.left * scale +
                " " +
                offset.top * scale +
                ")"
              }
            >
              {Array(this.maxlevel + 1)
                .fill()
                .map((_, i) => (
                  <g
                    key={i}
                    transform={`translate(0, ${i * (100 + HEIGHT) +
                      HEIGHT / 2})`}
                  >
                    <line
                      x1={95 - offset.left}
                      y1="0"
                      x2="10000"
                      y2="0"
                      strokeWidth="1"
                      stroke={Color.gradientMid}
                      strokeDasharray="10,10"
                    />
                  </g>
                ))}
              {dfsrootnode}
              {Array(this.maxlevel + 1)
                .fill()
                .map((_, i) => (
                  <g
                    key={i}
                    transform={`translate(${-offset.left}, ${i *
                      (100 + HEIGHT) +
                      HEIGHT / 2})`}
                  >
                    <LevelControl
                      level={i}
                      scale={scale}
                      collapsed={this.levelCollapsedStatus[i]}
                      expandOrCollapseLevel={c =>
                        this.expandOrCollapseLevel(i, c)
                      }
                    />
                  </g>
                ))}
              {contextMenu && (
                <ContextMenu
                  x={contextMenu.x}
                  y={contextMenu.y}
                  id={contextMenu.id}
                  onAdd={this.add}
                  onEdit={this.edit}
                  onCollapse={this.collapse}
                />
              )}
            </g>
          </svg>
        </Hammer>
      </div>
    );

    return (
      <div>
        <div id="chartPreText" style={{ textAlign: "center" }}>
          <br />
          <h2 style={{ marginBottom: 5 }}>Organization Chart</h2>
          <div className="toggle">
            <span
              onClick={e => this.setState({ isOrgView: true })}
              className={classnames("clickable", { selected: isOrgView })}
            >
              Organization View
            </span>
            <span
              onClick={e => this.setState({ isOrgView: false })}
              className={classnames("clickable", { selected: !isOrgView })}
            >
              Employees View
            </span>
          </div>
        </div>
        {mainChart}
      </div>
    );
  }
}

export default Chart;
